import * as React from "react";
const SvgNext1 = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7 4L11 8L7 12", stroke: "#B3B3B3", strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgNext1;
